import HTTP from '../common/http-common';

const END_POINT = '/page';

const listPage = () => HTTP.get(END_POINT, { cache: false });
const listPageForAdd = () => HTTP.get(END_POINT + "/foradd", { cache: false });

const insert = (data) => HTTP.post(END_POINT, {
    pageCode: data.pageCode,
    pageName: data.pageName,
    pageUrl: data.pageUrl,
    pageType: data.pageType,
    pageFunction: data.pageFunction
});
const update = (data) => HTTP.post(END_POINT + "/" + data.pageId, {
    pageCode: data.pageCode,
    pageName: data.pageName,
    pageUrl: data.pageUrl,
    pageType: data.pageType,
    pageFunction: data.pageFunction
});

const deletePage = (pageId) => HTTP.delete(END_POINT + "/" + pageId);

export {
    listPageForAdd,
    listPage,
    insert,
    update,
    deletePage
}